export const SET_EPISODE = 'SET_EPISODE';
export const SET_PLAY_STATUS = 'SET_PLAY_STATUS';

const setEpisode = (episode, state) => {
  return { ...state, nowPlaying: episode, isPlaying: true };
};

const setPlayStatus = (isPlaying, state) => {
  return { ...state, isPlaying: isPlaying };
};

export const nowPlayingReducer = (state, action) => {
  switch (action.type) {
    case SET_EPISODE:
      return setEpisode(action.payload, state);
    case SET_PLAY_STATUS:
      return setPlayStatus(action.payload, state);
    default:
      return state;
  }
};
